import { createAction } from 'redux-actions';

export const createActionCreator = (moduleName) => {
  const actionCreator = (actionDescription, payloadCreator) =>
    createAction(`${moduleName}/${actionDescription}`, payloadCreator);

  const actionCreatorWithStatuses = (actionDescription, payloadCreator, statusPayloadCreators) => [
    createAction(`${moduleName}/${actionDescription}`, payloadCreator),
    createAction(`${moduleName}/${actionDescription} - Success`, statusPayloadCreators?.success),
    createAction(`${moduleName}/${actionDescription} - Failure`, statusPayloadCreators?.failure),
  ];

  return {
    createAction: actionCreator,
    createActionWithStatuses: actionCreatorWithStatuses,
  };
};
